import { render, staticRenderFns } from "./friend.vue?vue&type=template&id=2c8c0994&scoped=true"
import script from "./friend.vue?vue&type=script&lang=js"
export * from "./friend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c0994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8c0994')) {
      api.createRecord('2c8c0994', component.options)
    } else {
      api.reload('2c8c0994', component.options)
    }
    module.hot.accept("./friend.vue?vue&type=template&id=2c8c0994&scoped=true", function () {
      api.rerender('2c8c0994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/main/src/page/manage/content/friend.vue"
export default component.exports